export default __webpack_public_path__ + "static/media/complementary--maximum-speed-limit-30--g1.df513571.png";